import { render, staticRenderFns } from "./OverviewTableReportDataPublicationLine.vue?vue&type=template&id=0c29fa5e&"
import script from "./OverviewTableReportDataPublicationLine.vue?vue&type=script&lang=ts&"
export * from "./OverviewTableReportDataPublicationLine.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports